import { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { sendDigestNow } from "../../lib/api";

export const DigestButton = () => {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await sendDigestNow();
      const c = r.counts;
      if (r.sent) toast.success(`Digest sent: ${c.overdue} overdue · ${c.due_today} due today · ${c.waiting} waiting`);
      else toast.error(r.recipients?.[0]?.error || "Digest could not be sent");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Digest could not be sent");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      data-testid="admin-send-digest-button"
      onClick={send}
      disabled={busy}
      title="Emails you the overdue / due-today / waiting-on-you digest right now (it also goes out weekdays at 7am Pacific)"
      className="inline-flex items-center gap-2 text-base text-slate-700 bg-white border border-slate-300 hover:border-cyan-500 rounded-lg px-4 py-2 transition-all disabled:opacity-60"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" />} Send digest now
    </button>
  );
};
